import { usePrincipal } from '@/common/principal/PrincipalContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Button, TextField } from '@mui/material';
import { useState } from 'react';
import { KrDialog } from '../dialog/Dialog';

export const ApprDecisionDialog = ({ data, closeDialog }) => {
  const { principal } = usePrincipal();
  const rsrc = useRsrc();

  const [error, setError] = useState(false);
  const [comment, setComment] = useState('Per Standard Operating Procedure (SOP)');

  const saveDecision = (approved) => {
    if (comment === '') {
      setError(true);
      return;
    }

    const type = approved ? 'APPR_ACCEPT' : 'APPR_REJECT';
    const events = data.runIds.map((runId) => {
      return {
        type,
        code: type,
        data: comment,
        msg: (type === 'APPR_ACCEPT' ? 'Approval' : 'Rejection') + ' Decision Submitted',
        ack: true,
        recBy: principal.username,
        cat: 'APPR',
        runId,
      };
    });

    rsrc.save('skdr', 'EVENT', events).then(() => {
      closeDialog({ type });
    });
  };

  return (
    <KrDialog
      title={data.title}
      closeDialog={() => closeDialog()}
      fullWidth
      maxWidth="md"
      buttons={[
        <Button onClick={() => closeDialog()}>Cancel</Button>,
        <Button onClick={() => saveDecision(false)}>Reject</Button>,
        <Button onClick={() => saveDecision(true)}>Approve</Button>,
      ]}
    >
      <TextField
        label="Comment"
        fullWidth
        multiline
        minRows={3}
        maxRows={10}
        error={error}
        value={comment}
        onChange={(event) => setComment(event.target.value)}
        helperText={error ? 'Please provide a reason for Approving or Rejecting ' : 'Reason for Approving/Rejecting'}
      />
    </KrDialog>
  );
};
